import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Item } from './styles';
import Dropdown from '@spa/shared/components/Dropdown';
import { ProfileContext } from '@spa/shared/contexts/profile';
import { TALK_TO_US } from '@spa/shared/components/Header/Desktop/tabs/tabsLinksData';
import LanguageSelector from '@spa/shared/components/LanguageSelector';
import Hamburger from '@spa/shared/svg/hamburger';

const accommodationProviderDropdownItems = [
  {
    key: 'Dashboard',
    link: `${process.env.AP_URL}bookings/requests`,
    separator: true,
    target: '_blank'
  },
  {
    key: 'Settings',
    link: `${process.env.AP_URL}account/details`,
    target: '_blank'
  },
  {
    key: 'How it works',
    href: () => process.env.HOW_IT_WORKS_URL,
    target: '_blank'
  },
  {
    link: `${process.env.HELP_URL}`,
    key: 'Help centre',
    separator: true,
    target: '_blank'
  },
  { key: 'Logout', link: '/logout' }
];

const guestDropdownItems = [
  {
    key: 'Your stays',
    link: '/dashboard/bookings',
    target: '_blank'
  },
  {
    key: 'Favourites',
    link: '/dashboard/wishlist',
    separator: true,
    target: '_blank'
  },
  {
    key: 'Settings',
    link: '/dashboard/profile',
    target: '_blank'
  },
  {
    key: 'Contact us',
    href: (language = 'en') => TALK_TO_US[language.toUpperCase()],
    target: '_blank'
  },
  {
    key: 'How it works',
    href: language => `${process.env.APP_URL}${language}/how-it-works`,
    target: '_blank'
  },
  {
    link: `${process.env.HELP_URL}`,
    key: 'Help centre',
    target: '_blank'
  },
  {
    key: 'Become an Ambassador',
    link: `${process.env.AMBASSADOR_URL}`,
    target: '_blank'
  },
  {
    key: 'Refer your friends',
    link: '/dashboard/referral',
    separator: true,
    target: '_blank'
  },
  { key: 'Logout', link: '/logout' }
];

const AuthenticatedMenu = ({
  isAccommodationProvider,
  hideUserTabs,
  changeLanguageHandler,
  changeLanguageByUrlHandler,
  guestName
}) => {
  const { t } = useTranslation('header');
  const { profile } = useContext(ProfileContext);
  const { basic_info: { full_name: { first = t('header:User') } = {} } = {} } = profile || {};

  const dropdownItems = isAccommodationProvider ? accommodationProviderDropdownItems : guestDropdownItems;

  const hello = t('header:Hello');

  return (
    <React.Fragment>
      <Item>
        <LanguageSelector onSelect={changeLanguageHandler} changeLanguageByUrlHandler={changeLanguageByUrlHandler} />
      </Item>
      {hideUserTabs ? null : (
        <Item>
          <Dropdown
            id={'usermenu'}
            values={dropdownItems.map(({ key, href, link, separator }) => {
              return {
                key,
                href,
                link,
                translation: t(`${key}`),
                separator
              };
            })}
            title={`${hello}, ${guestName || first}`}
            selected={''}
            onSelect={() => {}}
            Icon={Hamburger}
          />
        </Item>
      )}
    </React.Fragment>
  );
};

AuthenticatedMenu.propTypes = {
  isAccommodationProvider: PropTypes.bool,
  hideUserTabs: PropTypes.bool,
  changeLanguageHandler: PropTypes.func.isRequired,
  changeLanguageByUrlHandler: PropTypes.bool,
  guestName: PropTypes.string
};

export default AuthenticatedMenu;
